
export const USER_KEY = "USER_DATA"
export const BUTTON_PRIMARY = "BLUE"
export const SHOP_DATA = "SHOP_DATA"
export const VERSION = "1.3.3"
export const S3_URL = "https://lailaocf-bucket.s3.amazonaws.com/files/"
export const imageRender = (filename) => {
  return filename ? S3_URL + filename : "/assets/image/packxi-tab.png"
}

// color constants
export const APP_COLOR = "#1F3A60"
export const LINEAR_GRADIENT_BG = "#1F3A60"
export const COLOR_WHITE = "#FFFFFF";
export const COLOR_WHITE_200 = "#f7f7f7";
export const COLOR_RED_500 = "#DC2626";
export const UN_SELECTED_TAB_TEXT = "#222E3C";
export const APP_COLOR_FOCUS = "#1F3A60";
export const LINEAR_GRADIENT_BG_SP = "#1F3A60";


// url printer
export const ENTERNET_PORT = "http://localhost:9150/ethernet/image"
export const BLUETOOTH_PORT = "http://localhost:9150/bluetooth/image"
export const USB_PORT = "http://localhost:9150/usb/image"

export  const KEY ="$2b$10$sRx/uTHMydWDIdizURcgxecjFPbvnUNFzOwTl3lxNyV35zoFY4HnO";
// export  const PAYMENT_GATEWAY_API_URL = "https://payment-gateway.lailaolab.com:8000";   // dev
export  const PAYMENT_GATEWAY_API_URL = "https://payment-gateway.lailaolab.com";

export const COLOR_APP = "#1F3A60";
export const SHOP_SETTING_KEY = "SHOP_SETTING";
export const PRINT_ORDER = "print_order"


// permission in system
export const INLINE_PERMISSIONS = [

  {
    name: "ເຂົ້າເຖິງປະຫວັດການຂາຍ", value: "HISTORY_BILL_SALE",
  },
  {
    name: "ເຂົ້າເຖິງລາຍງານອອກໃບສະເໜີລາຄາ", value: "HISTORY_OFFERPRICE_BILL",
  },
  {
    name: "ລາຍງານປະຫວັດຄ້າງໜີ້", value: "HISTORY_INDEBTED_BILL",
  },
  {
    name: "ລາຍງານແກ້ໄຂສະຕ໋ອກ", value: "HISTORY_UPDATE_STOCK",
  },
  {
    name: "ປະຫວັດການລົບສິນຄ້າ", value: "HISTORY_DELETED_STOCK",
  },
  {
    name: "ລາຍງານຍອດຂາຍທັງໝົດ", value: "DASHBOARD_SALE",
  },
  {
    name: "ອອກໃບສະເໜີລາຄາ", value: "CREATE_QUOTAION",
  },
  {
    name: "ຈັດການພະນັກງານ", value: "STAFF_MANAGEMENT",
  },
  {
    name: "ລາຍງານສິນຄ້າໃກ້ໝົດ", value: "REPORT_STOCK_ALMOST",
  },
  {
    name: "ສາມາດເພິ່ມບົດບາດນຳໃຊ້ລະບົບ", value: "ROLE_MANAGEMENT",
  },
  {
    name: "ລາຍງານຂອງພະນັກງານເອງ", value: "REPORT_SALE_ONLY",
  },
  {
    name: "ເຂົ້າເຖິງລາຍການສັ່ງຊື້", value: "CREATE_INCOME_STOCK",
  },
  {
    name: "ເຂົ້າເຖິງຈັດການສະຕ໋ອກ", value: "STOCK_MANAGEMENTS",
  },
  {
    name: "ເຂົ້າເຖິງຈັດການຄສີນຄ້າຄົງຄັງ", value: "INVENTORY_MANAGEMENTS",
  },
  

];

export const CREATE_UPDATE_PERMISSINS = [
  {
    name: "ເພິ່ມສະຕ໋ອກ", value: "ADD_STOCK",
  },
  {
    name: "ແກ້ໄຂສະຕ໋ອກ", value: "EDIT_STOCK",
  },
  {
    name: "ແກ້ໄຂຂໍ້ມູນບິນຂາຍ", value: "EDIT_BILL",
  },
  {
    name: "ເພິ່ມໜວດໝູ່", value: "ADD_CATEGORIES",
  },
  {
    name: "ສ້າງລະຫັດບຣາໂຄດສິນຄ້າ", value: "GANERATE_QR_CODE",
  },
  {
    name: "ພະນັກງານຂາຍ: PRODUCTION_ORDER", value: "CAN_UPDATE_PRODUCTION_ORDER",
  },
  {
    name: "ພະນັກງານຂຶ້ນ Pattern: PATTERN", value: "CAN_UPDATE_PATTERN",
  },
  {
    name: "ພະນັກງານພິມ: PRINTING", value: "CAN_UPDATE_PRINTING",
  },
  {
    name: "ພະນັກງານລີດ: HEAT_TRANSFER", value: "CAN_UPDATE_HEAT_TRANSFER",
  },
  {
    name: "ພະນັກງານຕັດ: CUTTING", value: "CAN_UPDATE_CUTTING",
  },
  {
    name: "ພະນັກງານຫຍິບ: SEWING", value: "CAN_UPDATE_SEWING",
  },
  {
    name: "ພະນັກງານກວດ QC: QC", value: "CAN_UPDATE_QC",
  },
  {
    name: "ຢືນຢັນລູກຄ້າຮັບເຄື່ອງ: READY_TO_COMPLETE", value: "CAN_UPDATE_PRODUCTION_ORDER",
  },
]

export const DELETED_PERMISSIONS = [
  {
    name: "ລົບສະຕ໋ອກ", value: "DELETE_STOCK",
  },
  {
    name: "ລົບປະຫວັດບິນ", value: "DELETE_HISTORY_BILL",
  },
  {
    name: "ລົບລາຍຊື່ພະນັກງານ", value: "DELETE_STAFF",
  },
  {
  name: "ຈັດການສິນຄ້າເສຍຫາຍ", value: "SETTING_DAMAGED_INVENTORY",
  },
];

export const PRODUCTION_STATUS_PERMISSIONS = {
   PRODUCTION_ORDER: "CAN_UPDATE_PRODUCTION_ORDER",
    PATTERN: "CAN_UPDATE_PATTERN",
   PRINTING: "CAN_UPDATE_PRINTING",
   HEAT_TRANSFER: "CAN_UPDATE_HEAT_TRANSFER",
   CUTTING: "CAN_UPDATE_CUTTING",
   SEWING: "CAN_UPDATE_SEWING",
   QC: "CAN_UPDATE_QC",
   READY_TO_COMPLETE: "CAN_UPDATE_PRODUCTION_ORDER",
   COMPLETED: "CAN_UPDATE_COMPLETED",
 };

 export const checkProductionStatusPermission = (status, rolePermissions) => {
    const permission = PRODUCTION_STATUS_PERMISSIONS[status];
    return rolePermissions.includes(permission);
  };

 export const PRODUCTION_STATUS_FLOW = {
   PRODUCTION_ORDER: "PATTERN",
   PATTERN: "PRINTING",
   PRINTING: "HEAT_TRANSFER",
   HEAT_TRANSFER: "CUTTING",
   CUTTING: "SEWING",
   SEWING: "QC",
   QC: "READY_TO_COMPLETE",
   READY_TO_COMPLETE: "COMPLETED",
   COMPLETED: "COMPLETED",
 };

export const STOCK_OPTION_TAG_KEYS =  [
  // {value: "NORMAL", key: "ທຳມະດາ"},
  {    value: "PLUS", key: "ບວກເພີ່ມ"},
  // {    value: "FREE", key:"ແຖມຟຼີ"} 
];

export const STOCK_OPTION_ITEM_SALE_TAG_KEYS =  [
  { value: "VOLUME", key: "ບໍລິມາດ"},
  { value: "AMOUNT", key: "ຈຳນວນ"},
  // {    value: "FREE", key:"ແຖມຟຼີ"} 
];

export const STATUS_TAG_KEYS =  [
  { value: false, key: "ປີດ"},
  { value: true, key: "ເປີດ"},
  { value: "", key:"ທັງຫມົດ"} 
];

export const removeFields = (obj, fieldsToRemove) => {
  if (Array.isArray(obj)) {
      return obj.map((item) => removeFields(item, fieldsToRemove));
  } else if (obj !== null && typeof obj === "object") {
      return Object.fromEntries(
          Object.entries(obj)
          .filter(([key]) => !fieldsToRemove.includes(key)) // Remove unwanted fields
          .map(([key, value]) => [key, removeFields(value, fieldsToRemove)]) // Recursively process nested objects
      );
  }
  return obj;
};



